<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isPurchaseManager()">
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>Add Item to Inventory | Purchase Manager</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ $route.meta.title }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <br />
                <!-- main row for all icons  -->
                <div class="col-lg-12">
                    <div class="card card-primary card-outline">
                        <div class="card-header">Add Item</div>
                        <div class="card-body overflow-auto">
                            <form @submit.prevent="addItem">
                                <div class="form-group">
                                    <label>Item Name</label>
                                    <input
                                        type="text"
                                        placeholder="Enter item name"
                                        v-model="form.item_name"
                                        class="form-control"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Item Code</label>
                                    <input
                                        type="text"
                                        placeholder="Enter the item code"
                                        v-model="form.item_code"
                                        class="form-control"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Bill No.</label>
                                    <input
                                        type="text"
                                        placeholder="Enter the bill no"
                                        v-model="form.bill_no"
                                        class="form-control"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>IMEI No.</label>
                                    <input
                                        type="text"
                                        placeholder="Enter the IMEI no"
                                        v-model="form.imei_no"
                                        class="form-control"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Sl No.</label>
                                    <input
                                        type="text"
                                        placeholder="Enter the Sl. no"
                                        v-model="form.sl_no"
                                        class="form-control"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Branch</label>
                                    <v-select
                                        v-model="form.branch"
                                        type="text"
                                        label="branch"
                                        :options="branches"
                                        :reduce="
                                            (branches) => branches.branch_code
                                        "
                                        name="branch"
                                        placeholder="Select Branch"
                                        :value="
                                            (branches) => branches.branch_code
                                        "
                                    ></v-select>
                                </div>
                                <div class="form-group">
                                    <label>Room</label>
                                    <input
                                        type="text"
                                        placeholder="Enter the room"
                                        v-model="form.room"
                                        class="form-control"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Shelf</label>
                                    <input
                                        type="text"
                                        placeholder="Enter the shelf"
                                        v-model="form.shelf"
                                        class="form-control"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Rack</label>
                                    <input
                                        type="text"
                                        placeholder="Enter the rack"
                                        v-model="form.rack"
                                        class="form-control"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Item Charge</label>
                                    <input
                                        type="number"
                                        placeholder="Enter the item charge"
                                        v-model="form.item_charge"
                                        class="form-control"
                                        min="1"
                                    />
                                </div>
                                <div class="form-group">
                                    <button
                                        class="btn btn-primary"
                                        type="submit"
                                    >
                                        Add
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div class="card-footer"></div>
                    </div>
                </div>
                <!-- row end -->
            </section>
            <!-- /.content -->

            <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isPurchaseManager()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        console.log("Component mounted.");
    },

    created() {
        this.getBranches();
        this.getItem();
    },

    data() {
        return {
            form: new Form({
                bill_no: "",
                imei_no: "",
                sl_no: "",
                item_name: "",
                item_code: "",
                branch: "",
                room: "",
                shelf: "",
                rack: "",
                item_charge: "",
                id: "",
            }),

            branches: [],
        };
    },

    methods: {
        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branches = response.data;
            });
        },

        getItem() {
            axios
                .post("/api/getInventoryItem", { id: this.$route.params.id })
                .then((response) => {
                    this.form.fill(response.data);
                });
        },

        addItem() {
            this.form
                .post("/api/updateItem")
                .then((response) => {
                    if (response.data == 200)
                        toast.fire({
                            icon: "success",
                            title: "Updated",
                        });
                    else
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },
    },
};
</script>
